// tslint:disable
import { Divider, Modal, Row, Tree, Upload } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import { UploadFile, RcFile } from 'antd/lib/upload/interface';
import * as React from 'react';

import { IVisualCombination } from './ProductImages/ProductImages';
import { changePriority } from '../../../../helpers/Data/changePriority';

export interface IValueImagesProps {
  combination?: IVisualCombination;
  url: string;
  productId: number;
  valueImages: Array<UploadFile>;
  handleRemove: (f: UploadFile) => void;
  handleChange: (f: any) => void;
  handleOrderChange: (f: any) => void;
}

interface IValueImagesState {
  previewImage: GQL.IImage | undefined;
}

export default class ValueImages extends React.Component<IValueImagesProps, IValueImagesState> {

  constructor(props: IValueImagesProps) {
    super(props);

    this.handlePreview = this.handlePreview.bind(this);
    this.handleCancel = this.handleCancel.bind(this);

    this.state = { previewImage: undefined };
  }

  private prepareUploadImages() {
    return this.props.valueImages
      .filter((i: any) => i !== undefined)
      .map((i: any) => {
        return {
          ...i,
          uid: !i.id && i.originFileObj && i.originFileObj.uid ? i.originFileObj.uid : i.id,
          name: i.response ? i.response.file : i.file,
          url: `${this.props.url}/static/${i.file}`,
        };
      })
      .sort((a: any, b: any) => a.priority < b.priority ? -1 : 0 );
  }

  public render() {
    const { url, productId, handleChange, handleRemove } = this.props;
    const uploadAction = `${url}/images?productId=${productId}`;

    let nextPriority = this.getNewPriority();

    return (
      <Row>
        <Upload
          accept={'image/*'}
          action={`${uploadAction}&priority=${nextPriority}`}
          multiple={true}
          listType="picture-card"
          fileList={this.prepareUploadImages()}
          onRemove={handleRemove}
          onPreview={this.handlePreview}
          onChange={handleChange}
          beforeUpload={(file: any, fileList: RcFile[]) => {
            file.priority = nextPriority++;
            return true;
          }}
        >
          <div>
            <PlusOutlined />
            <div className="ant-upload-text">Upload</div>
          </div>
        </Upload>
        <Tree
          showLine={true}
          checkStrictly={true}
          onDrop={opt => this.onDrop(opt)}
          draggable={true}
          checkable={false}
          treeData={this.prepareUploadImages().map((f: any, index: number) => {
            f.key = index.toString()
            f.title = `${f.originFileObj ? ' ... uploading ... ' : f.name} (${f.priority})`
            return f
            }
          )}
        />
        <Modal visible={this.state.previewImage != undefined} footer={null} onCancel={this.handleCancel}>
          <img
            alt="example"
            style={{ width: '100%' }}
            src={this.state.previewImage && this.state.previewImage.file}
          />
        </Modal>
        <Divider/>
      </Row>
    );
  }

  private getNewPriority() {
    const { valueImages } = this.props;

    let biggestPriority = 0;
    for (const file of (valueImages as any[]) || []) {
      if (file.priority && file.priority > biggestPriority) {
        biggestPriority = file.priority;
      }
    }

    return biggestPriority + 1;
  }

  private onDrop(e: any) {
    const dropKey = parseInt(e.node.props.eventKey);
    const dragKey = parseInt(e.dragNode.props.eventKey);

    // kopie setříděných obrázků
    const images = [...this.props.valueImages] as Array<any>;
    images.sort((a, b) => a.priority > b.priority ? 1 : -1);

    // priority kam obrázek přesunout
    const priorityStart = images[ dragKey ].priority;
    const priorityEnd = images[ dragKey > dropKey ? dropKey : dropKey - 1 ].priority;

    // změna priorit v poli obrázků
    const newImages = changePriority(images, images[ dragKey ], priorityStart, priorityEnd);

    this.props.handleOrderChange({
      fileList: newImages,
    });
  }

  private handlePreview(f: UploadFile) {
    this.setState({
      previewImage: {
        file: f.url || f.thumbUrl
      } as GQL.IImage
    });
  }

  private handleCancel() {
    this.setState({
      previewImage: undefined
    });
  }
}



// WEBPACK FOOTER //
// ./src/scenes/Products/ProductDetail/ProductImagesTab/ValueImagesRow.tsx